export default __webpack_public_path__ + "static/media/Campra Accredited - Grey.7fce212b.svg";